export default __webpack_public_path__ + "static/media/down-filled-triangular-arrow.97acec0e.svg";